// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '20px 10px',
    borderRadius: 20,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
  },
  topContainer: {
    position: 'relative',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 30px',
    justifyContent: 'space-between',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    [theme.breakpoints.down(400)]: {
      padding: '10px 10px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  arrowBackContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  orderTime: {
    marginLeft: 5,
  },
  processing: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
  },
  paid: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  default: {
    backgroundColor: GlobalStyles.color.COLOR_DEFAULT,
  },
  contentContainer: {
    width: '90%',
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  contentTopContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  table: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  tableCell: {
    padding: 5,
    border: `1px solid ${GlobalStyles.color.COLOR_DEFAULT}`,
    color: 'black',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  statusImage: {
    width: 25,
    height: 25,
  },
  rowItem: {
    border: `1px solid ${GlobalStyles.color.COLOR_DEFAULT}`,
    padding: '5px !important',
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
});

export default styles;
